import auth0 from 'auth0-js'
import history from '../utils/history'
// const DOMAIN = (process.env.NODE_ENV === 'prod') ? 'https://dashboard-vms.mediastre.am':'http://localhost:3000'
// const tempDom = 'http://localhost:3000' //'https://dashboard-vms.mediastre.am' //'http://localhost:3000' //
// console.log(tempDom)
export default class Auth {
  auth0 = new auth0.WebAuth({
    domain: 'mediastream.auth0.com',
    clientID: 'Lair7h100Ep6tvFC0uHAdXrNI3P44AGk',
    redirectUri: `${process.env.REACT_APP_DOMAIN}/callback`,
    audience: 'https://mediastream.auth0.com/userinfo',
    responseType: 'token id_token',
    scope: 'openid'
  })

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  login() {
    this.auth0.authorize();
  }

  async handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          history.replace('/home');
          resolve(true)
        } else if (err) {
          history.replace('/home');
          console.log(err);
          resolve(false)
        }
      });
    })
  }

  setSession(authResult) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    // navigate to the home route
    history.replace('/home');
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // navigate to the home route
    history.replace('/home');
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }
}


// WEBPACK FOOTER //
// ./src/Auth/Auth.js